import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ message = 'Cargando...' }) => (
  <div className="d-flex flex-column align-items-center justify-content-center py-5">
    <Spinner animation="border" variant="primary" />
    <p className="mt-3">{message}</p>
  </div>
);

export default LoadingSpinner;
